import { render, staticRenderFns } from "./EDNAProject.vue?vue&type=template&id=559a71aa&scoped=true"
import script from "./EDNAProject.vue?vue&type=script&lang=js"
export * from "./EDNAProject.vue?vue&type=script&lang=js"
import style0 from "./EDNAProject.vue?vue&type=style&index=0&id=559a71aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559a71aa",
  null
  
)

export default component.exports